<template>
  <div class="program">
    <h2 class="fs30">我们的服务范围</h2>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="item-header" @mouseenter="iconMouseEnter(index)" @mouseleave="iconMouseLeave(index)">
          <img v-show="!item.toggle" :src="item.icon" />
          <img v-show="item.toggle" :src="item.icon1" />
        </div>
        <div class="item-body">
          <div class="item-body-title">{{item.title}}</div>
          <div class="item-body-desc">{{item.desc}}</div>
        </div>
        <div class="item-footer"></div>
        <img class="item-split" v-if="list.length !== index + 1" src="../../../../static/images/home_splitline@2x.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data () {
    return {
      list: [{
        id: 1,
        title: '移动APP开发',
        desc: '绽放工场拥有专业APP开发团队，为不同行业客户提供一站式手机软件APP定制开发服务',
        icon: require('../../../../static/images/home_h122px_app_icon_nor@2x.png'),
        icon1: require('../../../../static/images/home_h122px_app_icon_tap.gif'),
        toggle: false,
      }, {
        id: 2,
        title: '小程序开发',
        desc: '绽放工场为客户提供微信小程序及H5定制开发服务，是拥有丰富的开发案例及开发经验的公司',
        icon: require('../../../../static/images/home_h122px_applets_icon_nor@2x.png'),
        icon1: require('../../../../static/images/home_h122px_applets_icon_tap.gif'),
        toggle: false,
      }, {
        id: 3,
        title: 'H5 开发',
        desc: '至今，绽放工场以不同行业、不同规模的多家企业提供H5定制与营销服务',
        icon: require('../../../../static/images/home_h122px_h5_icon_nor@2x.png'),
        icon1: require('../../../../static/images/home_h122px_h5_icon_tap.gif'),
        toggle: false,
      }, {
        id: 5,
        title: 'WEB建设',
        desc: '提供ＰC端网站建设、手机WAP端网站建设、微信公众号开发，前端功能丰富，后台操作简单',
        icon: require('../../../../static/images/home_h122px_web_icon_nor@2x.png'),
        icon1: require('../../../../static/images/home_h122px_web_icon_tap.gif'),
        toggle: false,
      }]
    }
  },
  computed: {},
  methods: {
    iconMouseEnter (index) {
      this.list[index].toggle = true
    },
    iconMouseLeave (index) {
      this.list[index].toggle = false
    },
  },
  created () {},
}
</script>

<style scoped>
.program {
  position: relative;
  height: 630px;
}
.fs30 {
  font-size: 30px;
}
.program h2 {
  text-align: center;
  padding: 80px 0 60px 0;
}
.list {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: auto;
}
.item {
  width: 22%;
  height: 360px;
  border-radius: 8px;
  position: relative;
}
.item-header {
  width: 140px;
  height: 122px;
  margin: 32px auto 0;
}
.item-header img {
  width: 100%;
  height: 100%;
}
.item-body {
  padding: 16px 24px 0;
  font-size: 24px;
}
.item-body-title {
  font-size: 1em;
  color:rgba(51,51,51,1);
  font-family:Microsoft YaHei;
  font-weight:400;
  text-align: center;
}
.item-body-desc {
  font-size:14px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(153,153,153,1);
  margin-top: 16px;
}
.item-footer{
  width:48px;
  height:2px;
  background:rgba(209,23,23,1);
  margin: 26px auto 0;
}
.item-split {
  position: absolute;
  top: 0;
  right: -20px;
  width: 5px;
  height: 329px;
}
@media (max-width: 1199px) and (min-width: 992px){
  .list {
    padding: 0 10px;
  }
  .item-body-title {
    font-size: 0.9em;
  }
  .fs30 {
    font-size: 28px;
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .list {
    padding: 0 10px;
  }
  .item-body-title {
    font-size: 0.7em;
  }
  .item-body-desc {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .fs30 {
    font-size: 26px;
  }
}
@media screen and (max-width: 767px){
  .fs30 {
    font-size: 24px;
  }
  .list {
    padding: 0 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/service/myservice.vue